import type React from 'react';

import { Tooltip } from '../../../../../../components/Tooltip';

type Props = {
  tooltipContent: React.ReactNode;
  text: string | undefined;
  minWidth?: number;
  maxWidth?: number;
};

export const HighlightedText: React.FC<Props> = ({ tooltipContent, text, maxWidth = 200, minWidth = 130 }) => {
  return (
    <Tooltip content={tooltipContent} minWidth={minWidth} maxWidth={maxWidth}>
      <b>{text}</b>
    </Tooltip>
  );
};
